<template>
  <span :class="['ak-badge', `ak-badge--${type}`, { 'ak-badge--on': active }]"
    :title="titleText">
    <svg v-if="type === 'active'"
      width="12px"
      height="9px"
      viewBox="0 0 12 9">
      <polyline points="1 5 4 8 11 1"></polyline>
    </svg>
    <i v-else-if="type === 'featured'"
      class="fa-solid fa-star" />
    <i v-else-if="type === 'danger'"
      class="fa-solid fa-xmark" />
  </span>
</template>

<script>
const TITLES = {
  active: { on: 'Aktiivne', off: 'Mitteaktiivne' },
  featured: { on: 'Esiletõstetud', off: '' },
  danger: { on: 'Bug', off: '' },
}

export default {
  name: 'ak-badge',
  props: {
    active: { type: Boolean, default: false },
    type: { type: String, default: 'active' },
  },
  computed: {
    titleText() {
      const t = TITLES[this.type] || {}
      return this.active ? t.on : t.off
    }
  }
}
</script>

<style scoped>
/* Named .ak-badge, not .badge: utilities.scss uses .badge for the status pill,
   whose padding leaked in here and — with border-box on a fixed 24rem circle —
   squeezed the checkmark down to a sliver. */
.ak-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 24rem;
  height: 24rem;
  padding: 0;
  border-radius: 50%;
  border: 1rem solid var(--text-disabled);
  background: transparent;
  transition: all 0.2s ease;
}

.ak-badge svg,
.ak-badge i {
  flex: none;
}

.ak-badge svg {
  fill: none;
  stroke: white;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16rem;
  stroke-dashoffset: 16rem;
  transition: all 0.3s ease;
}

.ak-badge i {
  font-size: 11rem;
  color: var(--text-disabled);
  transition: all 0.2s ease;
}

.ak-badge--active.ak-badge--on {
  border-color: var(--green);
  background: var(--green);
}

.ak-badge--active.ak-badge--on svg {
  stroke-dashoffset: 0;
}

.ak-badge--featured.ak-badge--on {
  border-color: var(--yellow);
  background: var(--yellow);
}

.ak-badge--featured.ak-badge--on i {
  color: white;
}

.ak-badge--danger.ak-badge--on {
  border-color: var(--yellow);
  background: var(--yellow);
}

.ak-badge--danger.ak-badge--on i {
  color: white;
}
</style>
